import { render, staticRenderFns } from "./TemplateCard.vue?vue&type=template&id=c817142e&scoped=true"
import script from "./TemplateCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemplateCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TemplateCard.vue?vue&type=style&index=0&id=c817142e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c817142e",
  null
  
)

export default component.exports